import React from 'react';
import { useDropzone } from 'app/views/hooks/useDropzone';
import { analytics } from 'app/utils/analytics';
export function FilePickerBase(props) {
    const { className, maxFiles, onSelect, children } = props;
    const { getInputProps, open, acceptedFiles } = useDropzone({
        noDrag: true,
        maxFiles,
        onFileDialogCancel: () => analytics({
            action: 'FilePicker',
            label: 'cancel',
        }),
    });
    React.useEffect(() => {
        if (acceptedFiles.length) {
            analytics({
                action: 'FilePicker',
                label: 'select',
            });
            onSelect(acceptedFiles);
        }
    }, [acceptedFiles, onSelect]);
    const trigger = React.useMemo(() => {
        const importOpen = () => {
            analytics({
                action: 'FilePicker',
                label: 'open',
            });
            open();
        };
        return children(importOpen);
    }, [children, open]);
    return (React.createElement("div", { className: className },
        React.createElement("input", Object.assign({}, getInputProps({
            className: 'hide',
            id: 'media-upload-input',
        }))),
        trigger));
}
